import apiClient from './apiClient';
import type {
  AgentChatRequest,
  AgentTurnResponse,
  RegisterActivityRequest,
} from '../types/agent';

/**
 * Envía un turno conversacional al agente.
 * El backend devuelve el JSON del agente completo (estado + datos_extraidos).
 */
export async function sendAgentMessage(
  request: AgentChatRequest
): Promise<AgentTurnResponse> {
  // El backend (AgentController) recibe AgentChatRequest y devuelve AgentChatResponse
  // cuyo campo "reply" contiene el JSON serializado que el agente produce.
  // Lo parseamos aquí para que el componente trabaje con el objeto tipado.
  const response = await apiClient.post<{ sessionId: string; reply: string }>(
    '/v1/agent/chat',
    request
  );
  return JSON.parse(response.data.reply) as AgentTurnResponse;
}

/**
 * Persiste los datos extraídos al finalizar la sesión.
 */
export async function registerActivity(
  request: RegisterActivityRequest
): Promise<void> {
  await apiClient.post('/v1/agent/actividades', request);
}
